import React from 'react';
import './charts.css';

const sizeMap = {
  small: { height: '35vh', width: '100%' },
  medium: { height: '25vh', width: '100%' },
  large: { height: '70vh', width: '100%' },
};

const ChartContainer = ({ size = 'medium', height, width, children }) => {
  const resolvedSize = sizeMap[size] || sizeMap.medium;
  const containerHeight = height || resolvedSize.height;
  const containerWidth = width || resolvedSize.width;

  return (
    <div className={`chart-container size-${size}`} style={{ height: containerHeight, width: containerWidth }}>
      {children}
    </div>
  );
};

export default ChartContainer;
